module.exports = __webpack_public_path__ + "static/media/SR-logo-without-Circle2.e9fd82be.jpeg";